import React from "react";

import { useAppSelector } from "store";

import MultiSelectFilter from "components/filters/MultiSelectFilter";
import { CostChapter, selectCurrentChapter } from "modules/customer/insights/cost/costSlice";
import { chooseAllClusterStores, deselectAllClusterStores, selectClusterStores, toggleClusterStoreIsSelected } from "modules/customer/insights/cost/storeCosts/storeCostsSlice";
import {
    chooseAllClusterStores as costActionChooseAllClusterStores,
    deselectAllClusterStores as costActionDeselectAllClusterStores,
    selectClusterStores as costActionSelectClusterStores,
    toggleClusterStoreIsSelected as costActionToggleClusterStoreIsSelected
} from "modules/customer/insights/cost/storeCostActions/storeCostActionsSlice";

const ClusterStoresFilter: React.FC = () => {
    const currentChapter = useAppSelector(selectCurrentChapter);
    const clusterStores = useAppSelector(selectClusterStores);
    const costActionsClusterStores = useAppSelector(costActionSelectClusterStores);

    if (currentChapter === CostChapter.StoreCosts) {
        return (
            <MultiSelectFilter
                title="Cluster stores"
                items={clusterStores}
                chooseAllItems={chooseAllClusterStores}
                deselectAllItems={deselectAllClusterStores}
                toggleItemIsSelected={toggleClusterStoreIsSelected}
            />
        );
    }
    else if (currentChapter === CostChapter.StoreCostActions) {
        return (
            <MultiSelectFilter
                title="Cluster stores"
                items={costActionsClusterStores}
                chooseAllItems={costActionChooseAllClusterStores}
                deselectAllItems={costActionDeselectAllClusterStores}
                toggleItemIsSelected={costActionToggleClusterStoreIsSelected}
            />
        );
    }
    else {
        return null;
    }
};

export default ClusterStoresFilter;
